import {createReducer} from 'typesafe-actions';

import {UserActivitiesState} from '../../../types';
import { Actions } from '../../../store/epics';
import { requestResetPassword } from './actions';


const initialState: UserActivitiesState = {
    isLoading: false,
    passwordResetInProgress: false
}

export default createReducer<UserActivitiesState, Actions>(initialState)
.handleAction([requestResetPassword.success, requestResetPassword.failure], state => {
    return {
        ...state,
        isLoading: false,
        passwordResetInProgress: false
    };
})
.handleAction(requestResetPassword.request, (state, {payload: email}) => {
    return {
        ...state,
        isLoading: true,
        passwordResetInProgress: true,
        email,
    };
})

